﻿<script setup lang="ts">
    import { reactive, inject, onMounted } from 'vue';
    import { type PrePaidBalance } from './TextMessagesTypes';
    import { loadPrePaidBalance } from './TextMessages.access';
    import { ContextAccess, type CurrentSubscriptionReference } from '@shared/Root/Context.access';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';
    import { formatNumericText } from '@cwd/Shared/utils/formatNumericText';
    import { vTooltip } from '@shared/directives';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const contextAccess: ContextAccess = injectorAccess.injector.get(ContextAccess);

    const state = reactive<{
        prePaidBalance: PrePaidBalance | null;
        currentSubscription: CurrentSubscriptionReference | null;
    }>({
        prePaidBalance: null,
        currentSubscription: null,
    });

    onMounted(async () => {
        state.prePaidBalance = await loadPrePaidBalance();
        state.currentSubscription = contextAccess.state.currentSubscription;
    });
</script>

<script lang="ts"></script>

<template>
    <h5 class="sr-only">{{ $Resources.PrePaidHeading }}</h5>

    <p class="d-flex flex-wrap gap-xs align-items-baseline">
        <template v-if="state.prePaidBalance && state.currentSubscription">
            <span>{{ $Resources.PrePaidLabel }}:</span>
            <strong>{{ formatNumericText(state.prePaidBalance.AccountBalance, { precision: 2, numberWithSpace: true }) }}</strong>
            <small>{{ state.currentSubscription.ServiceLevelPrice.Currency.CurrencyCode }}</small>

            <span
                class="popover-trigger d-inline-block"
                v-show="state.prePaidBalance.SubscriptionBalance > 0"
                v-tooltip.right="$Resources.PrepayThisAccountLabel">
                <span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span>
            </span>

            <template v-if="state.prePaidBalance.SubscriptionBalance > 0">
                <span class="p-xs-l">{{ $Resources.SharedPrePaidLabel }}:</span>
                <strong>{{ formatNumericText(state.prePaidBalance.SubscriptionBalance, { precision: 2, numberWithSpace: true }) }}</strong>
                <small>{{ state.currentSubscription.ServiceLevelPrice.Currency.CurrencyCode }}</small>

                <span class="popover-trigger d-inline-block" v-tooltip.right="$Resources.PrepayAllAccountsLabel">
                    <span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span>
                </span>
            </template>
        </template>
    </p>
</template>

<style lang="less"></style>

<style scoped lang="less"></style>
